module.exports = __webpack_public_path__ + "img/1-backgroundthree.f278f467.png";